export { default } from './BorrowerCrmAvatar';
